import { datadogRum } from '@datadog/browser-rum';
import { getDefaultJWTCookie } from './getSpruceJWTCookie';

export const getCorrectBearerJwtForUrl = (url: string): string => {
  const cookiejwt = getDefaultJWTCookie();
  if (!cookiejwt) {
    datadogRum.addAction('Cookie Missing', { url });
  }
  return cookiejwt ?? '';
};
